import React, { memo } from "react";
import { Handle, Position } from "reactflow";
import { LuBot, LuWrench } from "react-icons/lu";
import { TbBinaryTree } from "react-icons/tb";

const nodeConfig = {
  agent: {
    icon: LuBot,
    bgClass: "bg-blue-50 dark:bg-blue-900/30",
    borderClass: "border-blue-300 dark:border-blue-600",
    iconColor: "text-blue-600 dark:text-blue-400",
    labelColor: "text-blue-800 dark:text-blue-200",
  },
  sub_agent: {
    icon: TbBinaryTree,
    bgClass: "bg-purple-50 dark:bg-purple-900/30",
    borderClass: "border-purple-300 dark:border-purple-600",
    iconColor: "text-purple-600 dark:text-purple-400",
    labelColor: "text-purple-800 dark:text-purple-200",
  },
  tool: {
    icon: LuWrench,
    bgClass: "bg-gray-50",
    borderClass: "border-gray-300",
    iconColor: "text-gray-600",
    labelColor: "text-gray-800",
  },
};

function AgentNode({ data }) {
  const { label, nodeType, highlighted } = data;
  const config = nodeConfig[nodeType] || nodeConfig.tool;
  const Icon = config.icon;

  return (
    <div
      className={`px-4 py-3 rounded-xl border shadow-sm min-w-[160px] max-w-[200px] transition-colors duration-200
        ${config.bgClass} ${highlighted ? "border-blue-500 ring-4 ring-blue-100 shadow-md dark:ring-blue-900/50" : config.borderClass}`}
    >
      <Handle type="target" position={Position.Left} className="!bg-gray-400 !w-2 !h-2" />
      <div className="flex items-center gap-2">
        <Icon size={16} className={highlighted ? "text-blue-600 dark:text-blue-300" : config.iconColor} />
        <span className={`text-sm font-medium truncate ${highlighted ? "text-blue-900 dark:text-blue-200" : config.labelColor}`}>
          {label}
        </span>
      </div>
      <Handle type="source" position={Position.Right} className="!bg-gray-400 !w-2 !h-2" />
    </div>
  );
}

export default memo(AgentNode);
